import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { LoginResponse } from "@app/core/user/domain/login.reponse";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { LoginMapper } from "@app/core/user/data/network/login.mapper";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ThirdPartyLoginMapper } from "@app/core/user/data/network/third-party-login.mapper";
import { ThirdPartyLoginCredentials } from "@app/core/user/domain/third-party-login-credentials";

@Injectable({
  providedIn: "root",
})
export class LoginWithFacebookWS {
  constructor(private handler: BaseHandler) {}

  execute(credentials: ThirdPartyLoginCredentials): Observable<LoginResponse> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.LOGIN_WITH_FACEBOOK_ENDPOINT())
      .setMethod(HttpMethod.post)
      .setBody(ThirdPartyLoginMapper.serialize(credentials))
      .build();

    return this.handler
      .execute(parameters)
      .pipe(map((response) => LoginMapper.deserialize(response)));
  }
}
